import { PatternValidationRegex } from '~domain/helper/validation-regex';
import { ErrorMessage, Rule } from '~domain/model/core/validation/rule';
import { BaseValidator } from '~domain/validators/core/base-validator';
import { RegexValidator } from '~domain/validators/core/basic-types/regex-validator';

export class CityValidator extends BaseValidator<string> {
  protected rules: Rule<string>[] = [this.createNullRule(), this.validateContent];

  private regexValidator: RegexValidator = new RegexValidator(PatternValidationRegex.ADDRESS_REGEX);

  private validateContent(value: string): ErrorMessage {
    return this.regexValidator.validate(value);
  }
}
